import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';
import './Member.css';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validation
    if (formData.new_password !== formData.confirm_password) {
      setError('新密碼與確認密碼不符');
      return;
    }

    if (formData.new_password.length < 8) {
      setError('新密碼必須至少8個字符');
      return;
    }

    setLoading(true);

    try {
      await authAPI.changePassword({
        old_password: formData.old_password,
        new_password: formData.new_password,
      });
      setSuccess(true);
      setFormData({
        old_password: '',
        new_password: '',
        confirm_password: '',
      });
    } catch (err) {
      setError(err.response?.data?.error || '更改密碼失敗，請重試');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="member-page">
      <div className="page-header">
        <h1>更改密碼</h1>
        <p>請輸入您的舊密碼和新密碼</p>
      </div>

      <div className="card">
        {success && (
          <div className="alert alert-success">
            ✓ 密碼更改成功！
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>舊密碼 *</label>
            <input
              type="password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
              placeholder="請輸入舊密碼"
              required
            />
          </div>

          <div className="form-group">
            <label>新密碼 *</label>
            <input
              type="password"
              name="new_password"
              value={formData.new_password}
              onChange={handleChange}
              placeholder="請輸入新密碼（至少8個字符）"
              required
              minLength={8}
            />
          </div>

          <div className="form-group">
            <label>確認新密碼 *</label>
            <input
              type="password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
              placeholder="請再次輸入新密碼"
              required
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? '處理中...' : '更改密碼'}
            </button>
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate('/member')}
            >
              取消
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
